var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 125 88.75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a6a6a6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 22.187,
    x2: 16.78,
    y1: 132.77,
    y2: 61.286,
    gradientTransform: "scale(2.137 .46795)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 26.261,
    x2: 69.193,
    y1: 51.747,
    y2: 26.685,
    gradientTransform: "matrix(1.0336 -.16389 .14965 .94376 -9.997 2.205)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 33.908,
    x2: 34.285,
    y1: 34.427,
    y2: 63.931,
    gradientTransform: "matrix(1.0336 -.16389 .14965 .94376 -.092646 1.3552)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f0f0",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 18.647,
    x2: 29.078,
    y1: 54.173,
    y2: 32.977,
    gradientTransform: "scale(1.8428 .54266)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9857 0 0 1.9857 -21.708 -27.002)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.98766 -.15661 .15661 .98766 -11.763 4.2456)",
    d: "m77.159 53.182a31.136 6.8182 0 1 1 -62.273 0 31.136 6.8182 0 1 1 62.273 0z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.258 50.271-7.4493-27.261 34.511-5.5666 1.5665 28.436c-2.058 2.058-7.8827 10.421-28.629 4.3914z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.251 50.277-7.3876-27.296 34.426-5.3393 1.5568 28.183c-1.7614 1.875-7.8494 10.482-28.595 4.4523z",
    fill: "url(#c)",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.93313 -.14796 .15661 .98766 -7.9062 2.0936)",
    d: "m61.477 24.773a18.523 5.4546 0 1 1 -37.045 0 18.523 5.4546 0 1 1 37.045 0z",
    fill: "url(#b)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.dcdd361919cded174d4f959e82c3f7a8.svg";
export { ForwardRef as ReactComponent };